<eze-registration-error
	formName="Coach"
	[url]="eventUrl"
	[eventName]="eventName"
	*ngIf="!paypalDefined; else noError"
></eze-registration-error>

<ng-template #noError>
	<eze-registration-closed
		formName="coach"
		[url]="eventUrl"
		*ngIf="isClosed"
	></eze-registration-closed>

	<eze-smart-form-container *ngIf="!isClosed">
		<div header>
			<h1>Coach Registration</h1>
		</div>
		<div body>
			<div
				[innerHtml]="successHtml"
				*ngIf="successHtml"
				style="margin: 20px"
			></div>

			<div *ngIf="!successHtml">
				<form novalidate [formGroup]="coachForm">
					<fieldset *ngIf="!isGuest">
						<eze-prefill-form
							[profile]="profile | async"
							[formReference]="coachForm"
							(selectedPrefill)="hasSelectedPrefill = true"
						></eze-prefill-form>
					</fieldset>

					<fieldset *ngIf="message">
						<div
							style="margin-bottom: 15px"
							[innerHtml]="message"
						></div>
					</fieldset>

					<ng-container *ngIf="hasSelectedPrefill || isGuest">
						<fieldset>
							<eze-registration-closing-warning
								formName="coach"
							></eze-registration-closing-warning>

							<eze-alert></eze-alert>

							<div class="row">
								<div class="col-sm-4">
									<eze-input-container label="First Name">
										<input
											ezeInput
											type="text"
											id="name_first"
											[showValidation]="showValidation"
											formControlName="name_first"
											[showValidation]="showValidation"
										/>
									</eze-input-container>
								</div>
								<div class="col-sm-4">
									<eze-input-container label="Middle Name">
										<input
											ezeInput
											type="text"
											id="name_middle"
											[showValidation]="showValidation"
											formControlName="name_middle"
										/>
									</eze-input-container>
								</div>
								<div class="col-sm-4">
									<eze-input-container label="Last Name">
										<input
											ezeInput
											type="text"
											id="name_last"
											[showValidation]="showValidation"
											formControlName="name_last"
										/>
									</eze-input-container>
								</div>

								<div class="clearfix"></div>

								<div class="col-sm-4">
									<eze-input-container>
										<select
											ezeInput
											id="gender"
											[showValidation]="showValidation"
											formControlName="gender"
										>
											<option value="">Select...</option>
											<option
												*ngFor="
													let gender of [
														'Male',
														'Female'
													]
												"
												[value]="gender"
											>
												{{ gender }}
											</option>
										</select>
									</eze-input-container>
								</div>

								<div class="clearfix"></div>
							</div>

							<eze-birth-date
								formControlName="birth_date"
								[showValidation]="showValidation"
							></eze-birth-date>

							<div class="row" *ngIf="!isStandardEvent">
								<div class="col-sm-12">
									<eze-input-container>
										<input
											ezeInput
											type="text"
											id="email"
											[showValidation]="showValidation"
											formControlName="email"
										/>
									</eze-input-container>
								</div>
							</div>
						</fieldset>

						<fieldset *ngIf="!!coachForm.get('noc')">
							<div class="row">
								<div class="col-sm-6">
									<eze-input-container label="NOC">
										<select
											ezeInput
											id="noc"
											[showValidation]="showValidation"
											formControlName="noc"
										>
											<option [value]="null">
												Select...
											</option>
											<option
												*ngFor="
													let country of countryCodes
												"
												[ngValue]="country.value"
											>
												{{ country.name }}
											</option>
										</select>
									</eze-input-container>
								</div>
							</div>
						</fieldset>

						<fieldset *ngIf="membershipIdField">
							<div class="row">
								<div class="col-sm-12">
									<eze-input-container
										[label]="
											membershipIdField?.label ||
											'Membership ID'
										"
									>
										<input
											ezeInput
											type="text"
											id="membership_id"
											formControlName="membership_id"
											[showValidation]="showValidation"
										/>
									</eze-input-container>
								</div>
							</div>
						</fieldset>

						<fieldset *ngIf="isStandardEvent">
							<!-- contact -->
							<eze-contact
								[formGroup]="coachForm"
								[showValidation]="showValidation"
								[isStandardEvent]="isStandardEvent"
							></eze-contact>
						</fieldset>

						<fieldset *ngIf="showSchoolForm">
							<div class="row">
								<div class="col-sm-12" formGroupName="school">
									<eze-input-container>
										<select
											ezeInput
											type="text"
											id="school"
											[showValidation]="showValidation"
											formControlName="id"
											[externalError]="
												coachForm
													.get('school')
													.getError('id')
											"
											required
											(change)="getPrice()"
										>
											<option value="null" disabled>
												Please Select...
											</option>
											<option
												*ngFor="let school of schools"
												[value]="school.id"
											>
												{{ generateSchoolName(school) }}
											</option>
											<option value="-1">
												Add New School
											</option>
										</select>
									</eze-input-container>
									<small
										>Please select 'Add New School' if your
										school is not in this list.</small
									>
									<br />
									<br />
								</div>
							</div>

							<div
								*ngIf="
									coachForm.get(['school', 'id']).value ===
									'-1'
								"
							>
								<h3>Add New School</h3>

								<div class="row" formGroupName="school">
									<div class="col-sm-12">
										<eze-input-container required>
											<input
												ezeInput
												type="text"
												id="name"
												[showValidation]="
													showValidation
												"
												formControlName="name"
												[externalError]="
													coachForm
														.get('school')
														.getError('name')
												"
											/>
										</eze-input-container>
									</div>

									<div class="col-sm-12">
										<eze-input-container required>
											<input
												ezeInput
												type="text"
												id="master"
												[showValidation]="
													showValidation
												"
												formControlName="master"
												[externalError]="
													coachForm
														.get('school')
														.getError('master')
												"
											/>
										</eze-input-container>
									</div>

									<div class="col-sm-12">
										<eze-input-container required>
											<input
												ezeInput
												type="text"
												id="address"
												[showValidation]="
													showValidation
												"
												formControlName="address"
												[externalError]="
													coachForm
														.get('school')
														.getError('address')
												"
											/>
										</eze-input-container>
									</div>

									<div class="col-sm-12">
										<eze-input-container required>
											<input
												ezeInput
												type="text"
												id="address_2"
												[showValidation]="
													showValidation
												"
												formControlName="address_2"
											/>
										</eze-input-container>
									</div>

									<div class="col-sm-5">
										<eze-input-container required>
											<input
												ezeInput
												type="text"
												id="city"
												[showValidation]="
													showValidation
												"
												formControlName="city"
												[externalError]="
													coachForm
														.get('school')
														.getError('city')
												"
											/>
										</eze-input-container>
									</div>

									<div class="col-xs-6 col-sm-3">
										<eze-input-container
											label="State"
											required
										>
											<select
												ezeInput
												id="school_state"
												[showValidation]="
													showValidation
												"
												formControlName="state"
												[externalError]="
													coachForm
														.get('school')
														.getError('state')
												"
											>
												<option value="">
													Select...
												</option>
												<option
													*ngFor="
														let state of stateList
													"
													[value]="state"
												>
													{{ state }}
												</option>
											</select>
										</eze-input-container>
									</div>

									<div class="col-xs-6 col-sm-4">
										<eze-input-container required>
											<input
												ezeInput
												type="text"
												id="zip"
												[showValidation]="
													showValidation
												"
												formControlName="zip"
												[externalError]="
													coachForm
														.get('school')
														.getError('zip')
												"
											/>
										</eze-input-container>
									</div>

									<div class="clearfix"></div>

									<div class="col-sm-6">
										<eze-input-container>
											<input
												ezeInput
												type="text"
												id="country"
												[showValidation]="
													showValidation
												"
												formControlName="country"
											/>
										</eze-input-container>
									</div>

									<div class="col-sm-6">
										<eze-input-container label="Website">
											<input
												ezeInput
												type="text"
												id="url"
												[showValidation]="
													showValidation
												"
												formControlName="url"
											/>
										</eze-input-container>
									</div>

									<div class="col-sm-6">
										<eze-input-container required>
											<input
												ezeInput
												type="text"
												id="phone"
												[showValidation]="
													showValidation
												"
												formControlName="phone"
												[textMask]="{
													mask: getPhoneMask(
														'school.phone'
													),
													guide: false
												}"
												[externalError]="
													coachForm
														.get('school')
														.getError('phone')
												"
											/>
										</eze-input-container>
									</div>
								</div>
							</div>
						</fieldset>

						<fieldset *ngIf="coachForm.get('document_id') && false">
							<eze-event-image-upload
								[eventId]="eventId"
								formControlName="document_id"
								[showValidation]="showValidation"
							></eze-event-image-upload>
						</fieldset>

						<!-- parent if minor -->
						<fieldset *ngIf="isMinor(coachForm)">
							<h3>Parent's Information (if minor)</h3>

							<!-- contact -->
							<div class="row">
								<div class="col-sm-4">
									<eze-input-container
										label="First Name"
										required
									>
										<input
											ezeInput
											type="text"
											id="parent_name_first"
											[showValidation]="showValidation"
											formControlName="parent_name_first"
											[externalError]="
												coachForm.getError(
													'parent_name_first'
												)
											"
										/>
									</eze-input-container>
								</div>

								<div class="col-sm-4">
									<eze-input-container label="Middle Name">
										<input
											ezeInput
											type="text"
											id="parent_name_middle"
											[showValidation]="showValidation"
											formControlName="parent_name_middle"
											[externalError]="
												coachForm.getError(
													'parent_name_middle'
												)
											"
										/>
									</eze-input-container>
								</div>

								<div class="col-sm-4">
									<eze-input-container
										label="Last Name"
										required
									>
										<input
											ezeInput
											type="text"
											id="parent_name_last"
											[showValidation]="showValidation"
											formControlName="parent_name_last"
											[externalError]="
												coachForm.getError(
													'parent_name_last'
												)
											"
										/>
									</eze-input-container>
								</div>

								<div class="clearfix"></div>

								<div class="col-sm-6">
									<eze-input-container
										label="Parent's Email"
										required
									>
										<input
											ezeInput
											type="text"
											id="parent_email"
											[showValidation]="showValidation"
											formControlName="parent_email"
											[externalError]="
												coachForm.getError(
													'parent_email'
												)
											"
										/>
									</eze-input-container>
								</div>

								<div class="col-sm-6">
									<eze-input-container
										label="Parent's Phone"
										*ngIf="isStandardEvent"
									>
										<input
											ezeInput
											type="text"
											id="parent_phone"
											[showValidation]="showValidation"
											formControlName="parent_phone"
											[externalError]="
												coachForm.getError(
													'parent_phone'
												)
											"
											[textMask]="{
												mask: getPhoneMask(
													'parent_phone'
												),
												guide: false
											}"
										/>
									</eze-input-container>
								</div>
							</div>
						</fieldset>

						<!--<fieldset>
						<h3>Divisions</h3>
						<br>
						<div *ngIf="divisions.length === 0">
							Sorry, there are no divisions available for this coach.
							<br>
							<br>
						</div>
						<eze-select-divisions [divisions]="divisions" (selectDivision)="onSelectDivision($event)"></eze-select-divisions>
					</fieldset>-->

						<fieldset>
							<eze-input-container
								label="I want to subscribe to emails"
							>
								<input
									ezeInput
									type="checkbox"
									id="subscription"
									formControlName="subscription"
									[showValidation]="showValidation"
								/>
							</eze-input-container>

							<eze-input-container
								label="*By checking this box I attest that I am of legal adult age or the parent/ legal guardian of the applicant."
							>
								<input
									ezeInput
									type="checkbox"
									id="legal_age"
									formControlName="legal_age"
									[showValidation]="showValidation"
								/>
							</eze-input-container>

							<eze-input-container
								label="*By clicking this box I attest that I have NOT been convicted of a crime involving physical violence or sex-related offenses."
								*ngIf="isStandardEvent"
							>
								<input
									ezeInput
									type="checkbox"
									id="no_crime"
									formControlName="no_crime"
									[showValidation]="showValidation"
								/>
							</eze-input-container>

							<eze-input-container [label]="null">
								<div>
									*Please check box to confirm that your name
									is not listed in USATKD SUSPENSION list
								</div>
								<input
									ezeInput
									type="checkbox"
									id="usatkd_suspension"
									formControlName="usatkd_suspension"
									[showValidation]="showValidation"
								/>
							</eze-input-container>

							<eze-input-container [label]="null">
								<div>
									*I consent to the
									<a (click)="openModal($event, 'waiver')">
										{{ waiver_description }}
									</a>
								</div>
								<input
									ezeInput
									type="checkbox"
									id="waiver"
									formControlName="waiver"
									[showValidation]="showValidation"
								/>
							</eze-input-container>

							<eze-input-container [label]="null">
								<div>
									*I agree with the
									<a (click)="openModal($event, 'terms')"
										>Terms and Conditions</a
									>
								</div>
								<input
									ezeInput
									type="checkbox"
									id="terms_and_conditions"
									formControlName="terms_and_conditions"
									[showValidation]="showValidation"
								/>
							</eze-input-container>

							<!-- <eze-input-container
								label="*By clicking this box I attest that I have read and fully understood the Liability Waiver, the Image Release, the Medical Treatment and the Terms and Conditions. I attest that the information I have provided is true and correct. I understand that this registration will be verified via email and/or phone."
								*ngIf="isStandardEvent"
							>
								<input
									ezeInput
									type="checkbox"
									id="catchall"
									formControlName="catchall"
									[showValidation]="showValidation"
								/>
							</eze-input-container> -->

							<!--<eze-input-container label="I am willing to compete against an uncontested coach outside of my division in an exhibition match. I attest that I am a coach of legal adult age or the parent / legal guardian of the registrant. I give my consent for myself / my child to participate in an exhibition match outside of the age and weight division if I am/my child is an uncontested coach or if I am/my child is a reasonable match for an uncontested coach. I understand and agree to be bound by the Liability Waiver which will be in full effect in case of an exhibition match.">
							<input ezeInput type="checkbox" id="exhibition_consent" formControlName="exhibition_consent" [showValidation]="showValidation">
						</eze-input-container>-->

							<button
								type="subimit"
								style="display: none"
							></button>
						</fieldset>

						<fieldset *ngIf="price">
							<h3>Price: {{ price | currency }}</h3>
							<br />
						</fieldset>
					</ng-container>
				</form>
			</div>
		</div>
		<div footer>
			<div [ngSwitch]="formState">
				<div *ngSwitchCase="'PAY'" class="buttons">
					<div style="margin-top: 10px; text-align: right;">
						<eze-paypal-button
							*ngIf="isProcessorPayPal && payload"
							[payload]="payload"
							[eventId]="eventId"
							entity="coaches"
							(success)="onSuccess($event)"
							(error)="onError($event)"
						></eze-paypal-button>
					</div>

					<eze-button
						(click)="goToPayment()"
						*ngIf="
							(!payload || isProcessorAuthNet) &&
							(hasSelectedPrefill || isGuest) &&
							!paymentCode
						"
					>
						Go to Payment
					</eze-button>
					<eze-button
						(click)="usePaymentCode()"
						*ngIf="
							isProcessorPaymentCode &&
							(hasSelectedPrefill || isGuest)
						"
					>
						Use Payment Code
					</eze-button>

					<eze-button
						(click)="useStripe()"
						*ngIf="!!payload && canPayWithStripe"
					>
						Pay With Card
					</eze-button>

					<eze-button
						(click)="usePayByUpload()"
						*ngIf="!!payload && canPayByUpload"
					>
						{{ payByUploadData?.label }}
					</eze-button>
				</div>

				<!-- <div *ngSwitchCase="'FREE'">
					<eze-button (click)="registerForFree()" *ngIf="(hasSelectedPrefill || isGuest) && !paymentCode">Register</eze-button>
				</div> -->

				<div *ngSwitchCase="'RESET_FORM'">
					<eze-button (click)="resetForm()" *ngIf="successHtml"
						>Register Another Coach</eze-button
					>
				</div>
			</div>
		</div>
	</eze-smart-form-container>

	<eze-waiver
		#waiverModal
		[header]="waiverHeader"
		[waiverText]="waiverText"
	></eze-waiver>
	<eze-terms #termsModal></eze-terms>

	<eze-authorize-net-payment
		#authorizeModal
		[price]="price"
		[eventId]="eventId"
		[payload]="payload"
		entity="coaches"
		(success)="onSuccess($event)"
	></eze-authorize-net-payment>

	<eze-payment-code-modal
		#paymentCodeModal
		[eventId]="eventId"
		[payload]="payload"
		entity="coaches"
		(success)="onSuccess($event)"
		[paymentCode]="paymentCode"
	></eze-payment-code-modal>

	<eze-pay-by-upload-modal
		#payByUploadModal
		*ngIf="canPayByUpload"
		[payload]="payload"
		entity="coaches"
		(success)="onSuccess($event)"
		[eventId]="eventId"
		[title]="payByUploadData?.label"
		[instructions]="payByUploadData?.instructions"
		[bypassDocument]="payByUploadData?.bypass_document"
	></eze-pay-by-upload-modal>

	<eze-stripe-payment-modal
		#payByStripeModal
		*ngIf="stripePublicKey"
		[stripeId]="stripePublicKey"
		[payload]="payload"
		[price]="price"
		entity="coaches"
		(success)="onSuccess($event)"
		[eventId]="eventId"
	></eze-stripe-payment-modal>

	<!-- <pre>{{coachForm.value | json}}</pre> -->
</ng-template>
